/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IGetFoldersRequest, TGetFoldersModel, IMappers, TGetFoldersResponse } from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IGetFoldersResponse } from '../../entities/user_folder/GetFoldersResponse';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createGetFoldersModel(parameters: IGetFoldersRequest): TGetFoldersModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'GET',
    microserviceName: 'favorites',
    pathApi: '/v1/get-folders/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      parameters,
    },
  };
}

export interface IGetFoldersOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IGetFoldersRequest;
}

export async function fetchGetFolders<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetFoldersOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TGetFoldersResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createGetFoldersModel(parameters),
    config,
  )) as FetchResponse<TGetFoldersResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetFoldersResponse, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TGetFoldersResponse>;
}
